<template>
  <div id="SectionCalculator">
    <UIContainer class="SectionCalculator__container">
      <div class="SectionCalculator__content">
        <div class="SectionCalculator__left">
          <h1 class="SectionCalculator__title">
            Quick GHG emissions calculator
          </h1>

          <p class="SectionCalculator__description">
            Use our free, guided assessment to estimate your company's carbon
            footprint. It's the perfect first step to identify your emission
            hotspots and understand the scope of your reporting needs.
          </p>

          <UIButton size="xl" class="SectionCalculator__cta">
            Check now
          </UIButton>
        </div>

        <div class="SectionCalculator__right">
          <img
            src="../assets/calculator.png"
            alt="Calculator"
            class="SectionCalculator__image"
          />
        </div>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionCalculator {
  .SectionCalculator__container {
    padding-top: 2rem;

    @include md {
      padding-top: 4rem;
    }
  }

  .SectionCalculator__content {
    display: flex;
    gap: 2rem;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    @include md {
      flex-direction: row;
    }
  }

  .SectionCalculator__title {
    @include font-size-30px();
    font-weight: 600;
    color: $color-ui-gray-cool-900;

    @include md {
      @include font-size-60px();
    }
  }

  .SectionCalculator__description {
    margin-top: 1.5rem;
    color: $color-ui-gray-cool-600;
    max-width: 30rem;
  }

  .SectionCalculator__cta {
    margin-top: 2rem;
  }

  .SectionCalculator__right {
    width: 100%;
    max-width: 34.375rem;
  }

  .SectionCalculator__image {
    width: 100%;
    max-width: 34.375rem;
    height: auto;
    max-height: 28.625rem;
  }
}
</style>
